export default __webpack_public_path__ + "ca2ff057f36b71f9d3232955b2e7ea6f.png";